import { Injectable } from '@angular/core';

import { EntityIdApiModel } from '../../../api/targeting/model/entity-id-api-model';
import { TargetingMiscApi } from '../../../api/targeting/targeting-misc.api';
import { Mention } from '../../Mentions/models/mention';

@Injectable()
export class RecentCoverageService {

    constructor(
        protected targetingMiscApi: TargetingMiscApi,
    ){}


    applyTwitterInfo(mentions: Mention[]): void {
        this.targetingMiscApi.getTwitterInfo(mentions.map(mention => {

            return <EntityIdApiModel> {
                outletUuid: mention.publication.uuid,
                contactUuid: mention.author.uuid
            };
        })).subscribe(twitterInfos => {
            twitterInfos.filter(info => info.id.outletUuid).forEach(info => {
                mentions.forEach(mentionItem => {
                    if (mentionItem.publication.uuid && mentionItem.publication.uuid === info.id.outletUuid) {
                        mentionItem.twitterHandle = info.twitterHandle;
                        mentionItem.avatarUrl = info.avatarUrl;
                    }
                });
            });

            twitterInfos.filter(info => info.id.contactUuid).forEach(info => {
                mentions.forEach(mentionItem => {
                    if (!mentionItem.avatarUrl && mentionItem.author.uuid === info.id.contactUuid) {
                        mentionItem.twitterHandle = info.twitterHandle;
                        mentionItem.avatarUrl = info.avatarUrl;
                    }
                });
            });
        });
    }
}
